// src/components/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { currentUser, businessProfile } = useAuth();
  if (!currentUser) return <Navigate to="/login" replace />;
  if (!businessProfile) return null; // still loading
  if (businessProfile.role === "admin") return <Navigate to="/admin" replace />;
  // Gate: businesses created under the old signup flow already have a
  // businessName (it was required then), so this only ever catches
  // genuinely new, not-yet-onboarded accounts — no migration needed.
  if (!businessProfile.businessName) return <Navigate to="/onboarding" replace />;
  return children;
}